import { render, staticRenderFns } from "./AddReferent.vue?vue&type=template&id=a67c4674&"
import script from "./AddReferent.vue?vue&type=script&lang=js&"
export * from "./AddReferent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports